export const lowerCaseString = (str: string | null | undefined) => {
    if (!str) return ''

    return str.toLocaleLowerCase()
}